import styled from 'styled-components';

export const AuthContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 40px;
  
  img {
    width: 160px;
  }
`;

export const BodyAuth = styled.section`
  background: #fafafa;
`;

export const BoxAuth = styled.div`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 40px;

  span.beta {
    color: var(--primary-7);
    text-align: center;
    font-family: Barlow;
    font-size: 10px;
    font-style: italic;
    font-weight: 500;
    line-height: 10px; /* 100% */
    letter-spacing: -0.4px;
    margin-left: 5px;
  }
  .ant-input-prefix {
    color: rgba(0, 0, 0, 0.25);
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .ant-checkbox+span {
    margin-top: 2px;
  }
  @media screen and (min-width: 576px) {
    min-width: 400px;
  }
`;

export const modalTitle = styled.div`
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 12px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -0.02em;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const TitleModalLogout = modalTitle;

export const PasswordItem = styled.div`
  .ant-form-item {
    &.ant-form-item-has-error {
      .ant-input-password {
        border-color: #ff4d4f;

        &:focus {
          box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
        }
      }
    }
  }
`;
